import React from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './searchmodal.scss';

const year = new Date().getFullYear()

class SearchModal extends React.Component {
    constructor(props){
        super(props);
        this.state = {
          searchKey:"",
        }
        this.closeModal = this.closeModal.bind(this)
      }

  closeModal(e){
    this.props.setval({searchModal:false})
  }
  render(){

    return (
      <div className="searchmain">
           <Modal show={this.props.searchModal} onHide={this.closeModal}>
                <Modal.Header closeButton>
                <Modal.Title className={"mate"}>Search our Products</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className={"searchbody"} style={{display:"flex",flexDirection:"row",justifyContent:"space-between",alignItems:"center"}}>
                    <input style={{width:"80%"}} type="text" placeholder="Search Products" name="search" onChange={(e)=>{
                          const key = e.target.value.toLowerCase()
                          this.setState({searchKey:key})
                        }} 
                        onKeyDown={(e)=>{
                          if(e.key === "Enter"){
                            this.props.searchProduct(e,this.state.searchKey)
                          }
                        }}
                        />

                        <Button variant="primary" onClick={(e)=>{
                          this.props.searchProduct(e,this.state.searchKey)
                      }}>
                          Search
                      </Button>
                  </div>
                </Modal.Body>
                <Modal.Footer>
               
                </Modal.Footer>
            </Modal>
        


      </div>
    );


  }
}

export default SearchModal;
